import React from 'react';
import { motion } from 'framer-motion';
import { FadeIn, SectionDivider, CtaButton } from '../ui';
import { Shield, AlertTriangle, Lock, Smartphone, Zap, Globe, RefreshCcw } from 'lucide-react';
export const OfferSections = () => {
  return <div className="bg-mystic-900 relative" data-id="element-180">
      {/* BLOQUE 12: LA INVERSIÓN */}
      <section id="pricing" className="py-20 px-4 relative scroll-mt-16" data-id="element-181">
        <div className="absolute inset-0 bg-radial-glow opacity-40 pointer-events-none" data-id="element-182"></div>
        <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-183">
          <FadeIn data-id="element-184">
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-8" data-id="element-185">
              ¿Cuánto te cuesta recuperar al amor de tu vida?
            </h2>

            <div className="text-lg text-text-secondary space-y-4 mb-12" data-id="element-186">
              <p data-id="element-187">
                Los brujos que te estafaron antes te cobraron $300, $500, $1,000
                por rituales que hicieron sin tu energía, sin tu conexión, sin
                ningún resultado real.
              </p>
              <p data-id="element-188">
                Este manual tiene 20 módulos completos. El ritual de las 3
                noches paso a paso. Los decretos exactos. El protocolo de
                silencio. Todo lo que necesitas para recuperar al amor de tu
                vida usando tu propio poder.
              </p>
              <p className="text-xl text-white font-medium mt-8" data-id="element-189">¿El precio?</p>
            </div>

            <div className="glass-panel p-10 rounded-2xl border-gold/30 relative overflow-hidden" data-id="element-190">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-gold to-transparent" data-id="element-191"></div>

              <div className="flex justify-center items-center gap-4 md:gap-8 mb-6 text-xl md:text-3xl font-bold text-text-secondary/50" data-id="element-192">
                <motion.span initial={{
                opacity: 0
              }} whileInView={{
                opacity: 1
              }} viewport={{
                once: true
              }} transition={{
                delay: 0.2
              }} className="relative" data-id="element-193">
                  $97
                  <motion.div initial={{
                  width: 0
                }} whileInView={{
                  width: '100%'
                }} viewport={{
                  once: true
                }} transition={{
                  delay: 0.5,
                  duration: 0.3
                }} className="absolute top-1/2 left-0 h-1 bg-burgundy -translate-y-1/2" data-id="element-194"></motion.div>
                </motion.span>
                <motion.span initial={{
                opacity: 0
              }} whileInView={{
                opacity: 1
              }} viewport={{
                once: true
              }} transition={{
                delay: 0.8
              }} className="relative" data-id="element-195">
                  $47
                  <motion.div initial={{
                  width: 0
                }} whileInView={{
                  width: '100%'
                }} viewport={{
                  once: true
                }} transition={{
                  delay: 1.1,
                  duration: 0.3
                }} className="absolute top-1/2 left-0 h-1 bg-burgundy -translate-y-1/2" data-id="element-196"></motion.div>
                </motion.span>
                <motion.span initial={{
                opacity: 0
              }} whileInView={{
                opacity: 1
              }} viewport={{
                once: true
              }} transition={{
                delay: 1.4
              }} className="relative" data-id="element-197">
                  $27
                  <motion.div initial={{
                  width: 0
                }} whileInView={{
                  width: '100%'
                }} viewport={{
                  once: true
                }} transition={{
                  delay: 1.7,
                  duration: 0.3
                }} className="absolute top-1/2 left-0 h-1 bg-burgundy -translate-y-1/2" data-id="element-198"></motion.div>
                </motion.span>
              </div>

              <motion.div initial={{
              scale: 0.8,
              opacity: 0
            }} whileInView={{
              scale: 1,
              opacity: 1
            }} viewport={{
              once: true
            }} transition={{
              delay: 2,
              type: 'spring',
              stiffness: 100
            }} className="text-6xl md:text-8xl font-bold text-gold mb-6 drop-shadow-[0_0_20px_rgba(200,168,75,0.4)]" data-id="element-199">
                Solo $12 USD
              </motion.div>

              <p className="text-xl text-white font-serif italic mb-2" data-id="element-200">
                Menos de lo que cuesta un café.
              </p>
              <p className="text-text-secondary" data-id="element-201">
                No es un error. Es intencional.
              </p>
              <p className="text-text-primary mt-4 font-medium" data-id="element-202">
                Decidí que no hubiera ninguna excusa económica entre tú y el
                poder que siempre fue tuyo.
              </p>
            </div>
          </FadeIn>
        </div>
      </section>

      {/* BLOQUE 13: GARANTÍA */}
      <section className="py-8 px-4" data-id="element-203">
        <div className="max-w-3xl mx-auto" data-id="element-204">
          <FadeIn data-id="element-205">
            <div className="bg-mystic-800 border border-gold/30 rounded-xl p-8 md:p-10 flex flex-col md:flex-row items-center md:items-start gap-8 shadow-[0_0_30px_rgba(200,168,75,0.1)]" data-id="element-206">
              <div className="text-gold bg-gold/10 p-4 rounded-full shrink-0" data-id="element-207">
                <Shield size={48} data-id="element-208" />
              </div>
              <div className="text-center md:text-left" data-id="element-209">
                <h3 className="text-2xl font-bold text-white mb-4" data-id="element-210">
                  GARANTÍA TOTAL DE 7 DÍAS
                </h3>
                <p className="text-text-secondary mb-4" data-id="element-211">
                  Si en los próximos 7 días sientes que este manual no te
                  entregó el conocimiento, la claridad y las herramientas que
                  prometí, te devuelvo cada centavo.
                </p>
                <p className="text-text-secondary mb-6" data-id="element-212">
                  Sin formularios complicados. Sin preguntas. Sin drama. Así de
                  seguro estoy de lo que tienes en tus manos.
                </p>
                <p className="text-gold font-bold text-lg" data-id="element-213">
                  El riesgo es completamente mío.
                  <br data-id="element-214" />
                  La oportunidad es completamente tuya.
                </p>
              </div>
            </div>
          </FadeIn>
        </div>
      </section>

      {/* BLOQUE 14: URGENCIA */}
      <section className="py-8 px-4" data-id="element-215">
        <div className="max-w-3xl mx-auto" data-id="element-216">
          <FadeIn data-id="element-217">
            <div className="bg-burgundy/20 border border-burgundy rounded-xl p-6 md:p-8 flex items-start gap-4" data-id="element-218">
              <AlertTriangle className="text-burgundy shrink-0 animate-pulse-slow" size={32} data-id="element-219" />
              <div data-id="element-220">
                <h3 className="text-xl font-bold text-white mb-2 uppercase tracking-wider" data-id="element-221">
                  Precio de Lanzamiento
                </h3>
                <p className="text-text-primary mb-2" data-id="element-222">
                  Este manual se publicó a $12 USD como precio de introducción
                  para los primeros compradores. Una vez terminada esta etapa de
                  lanzamiento, el precio sube a $27 de forma permanente.
                </p>
                <p className="text-text-secondary text-sm mb-4" data-id="element-223">
                  No habrá excepciones ni cupones después.
                </p>
                <p className="text-white font-bold" data-id="element-224">
                  Si estás viendo $12 USD en este momento, ese precio aún está
                  activo. No lo dejes para mañana.
                </p>
              </div>
            </div>
          </FadeIn>
        </div>
      </section>

      <SectionDivider data-id="element-225" />

      {/* BLOQUE 15: CTA FINAL */}
      <section className="py-16 px-4 text-center relative" data-id="element-226">
        <div className="absolute inset-0 bg-radial-burgundy opacity-50 pointer-events-none" data-id="element-227"></div>
        <div className="max-w-4xl mx-auto relative z-10" data-id="element-228">
          <FadeIn data-id="element-229">
            <div className="mb-12" data-id="element-230">
              <p className="text-2xl md:text-3xl font-serif text-white italic mb-4" data-id="element-231">
                La persona que amas no se fue para siempre.
              </p>
              <p className="text-xl text-text-secondary mb-6" data-id="element-232">
                Solo está esperando que tú actives el hilo que los une.
              </p>
              <p className="text-2xl font-bold text-gold" data-id="element-233">
                Los brujos apostaron a que nunca lo descubrirías.
                <br data-id="element-234" />
                Hoy les demuestras que se equivocaron.
              </p>
            </div>

            <CtaButton variant="final" className="mb-10" data-id="element-235">
              🔴 QUIERO EL AMARRE ANCESTRAL DE 3 NOCHES — SOLO $12 USD
            </CtaButton>

            {/* Trust Seals */}
            <div className="flex flex-wrap justify-center gap-x-6 gap-y-4 text-sm text-text-secondary" data-id="element-236">
              <div className="flex items-center gap-2" data-id="element-237">
                <Lock size={16} className="text-gold/70" data-id="element-238" /> Pago 100% seguro y
                encriptado
              </div>
              <div className="flex items-center gap-2" data-id="element-239">
                <Smartphone size={16} className="text-gold/70" data-id="element-240" /> Funciona en
                celular, tablet y computadora
              </div>
              <div className="flex items-center gap-2" data-id="element-241">
                <Zap size={16} className="text-gold/70" data-id="element-242" /> Acceso inmediato
                después del pago
              </div>
              <div className="flex items-center gap-2" data-id="element-243">
                <RefreshCcw size={16} className="text-gold/70" data-id="element-244" /> Garantía de
                devolución de 7 días
              </div>
              <div className="flex items-center gap-2" data-id="element-245">
                <Globe size={16} className="text-gold/70" data-id="element-246" /> Disponible en
                cualquier país
              </div>
            </div>
          </FadeIn>
        </div>
      </section>
    </div>;
};